import { knmErpMapStatusNameByNewName } from '../constants/knmErpMapStatusNameByNewName';

export const getNewMappedStatus = (status: string, isException?: boolean) => {
  if (status === 'Не может быть проведено' && isException) {
    return 'Завершено';
  }

  return knmErpMapStatusNameByNewName[status];
};
